module.exports = {"title":"redesign","body":"<h1>Loving gatsby</h1>\n<p>I just updated my site here with a static page generated with gatsby and am really liking it thus far.</p>\n"}


//////////////////
// WEBPACK FOOTER
// ./blog/20170201.md
// module id = 648
// module chunks = 0